// extracted by mini-css-extract-plugin
module.exports = {"list":"Items_list__3d__8","card":"Items_card__UUGgJ","loader":"Items_loader__XnsCS"};